import router from 'next/router';
import { routes } from '../config/routes';
import { CHANNEL_ID_TYPES } from '../constants/common';
import { SessionStorageKeys } from '../constants/storage';
import { removeFromStorage } from '../utils/storage';

export const navigateToLogin = (channelId?: string) => {
  switch(channelId){
    case CHANNEL_ID_TYPES.MBK:
      router.push(routes.SESSION_EXPIRED.url);  
      break;
    default:
      window.location.assign(process.env.OMNI_LOGIN);
  }
};

export const navigateToLoginInNewTab = (channelId?: string) => {
  switch(channelId){
    case CHANNEL_ID_TYPES.MBK:
      router.push(routes.SESSION_EXPIRED.url);  
      break;
    default:
      window.location.assign(process.env.OMNI_LOGIN);
  }
};

export const navigateToInvest = () => {
  removeFromStorage(SessionStorageKeys.APPLICATION_LOADED);
  window.location.assign(window.location.protocol + '//' + process.env.PFM_HOST);
};

export const navigateToMutualFund = (url?: string) => {
  window.location.assign(window.location.protocol + '//' + process.env.MUTUAL_FUND_HOST + '?navigateTo=' + url);
};

export const navigateToUrl = (toUrl: string) => {
  removeFromStorage(SessionStorageKeys.APPLICATION_LOADED);
  window.location.assign(toUrl)
}
